import {FilterOperator} from "./filter-operator.enum";
import {FilterQueryConfig} from "./filter-query-config.model";
import {FilterSort} from "./filter-sort.enum";

export class FilterPortalConfig extends FilterQueryConfig {

  static DEFAULT_RENDERER = "default";

  sort: FilterSort = FilterSort.FREQUENCY;
  hide = false;
  hideSearch = false;
  disableExclude = false;
  disableOr = false;
  defaultOperator: FilterOperator = FilterOperator.AND;
  renderer = FilterPortalConfig.DEFAULT_RENDERER;
  force = false;
  useKeyword = true;
  useAll = false;
  additionalConfigs: FilterPortalConfig[] = [];

  constructor(attr: {
    name?: string,
    show?: boolean,
    translation?: string,
    limitNestedIteration?: number,
    minElements?: number,
    sort?: string,
    defaultOperator?: string,
    hide?: boolean,
    types?: string[],
    showMore?: boolean,
    disableExclude?: boolean,
    disableOr?: boolean,
    renderer?: string,
    force?: boolean,
    useAll?: boolean,
    additionalConfigs?: any[],
    useKeyword?: boolean
  }) {
    super(attr);
    if (attr.hide) {
      this.hide = attr.hide;
    }
    if (attr.disableExclude) {
      this.disableExclude = attr.disableExclude;
    }
    if (attr.disableOr) {
      this.disableOr = attr.disableOr;
    }
    if (attr.renderer) {
      this.renderer = attr.renderer;
    }
    if (attr.force) {
      this.force = attr.force;
    }
    if (attr.useAll) {
      this.useAll = attr.useAll;
    }
    if (attr.additionalConfigs) {
      attr.additionalConfigs.forEach(rawAdditionalConfig => this.additionalConfigs.push(new FilterPortalConfig(rawAdditionalConfig)));
    }

    if (attr.limitNestedIteration) {
      this.limitNestedIteration = attr.limitNestedIteration;
    } else {
      this.limitNestedIteration = 5;
    }
    if (attr.useKeyword != undefined) {
      this.useKeyword = attr.useKeyword;
    }
    this.safeAction(() => this.defaultOperator = FilterOperator[attr.defaultOperator]);
    this.safeAction(() => this.sort = FilterSort[attr.sort]);
  }
}
